import { axiosBasic, axiosBearer } from "../config/axios-common";
import { AddressType } from "../forms/shared/AddressDataForm";
import ResolveAttrValueIfNull from "../helpers/ValidateAttrs/ValidateAttrs";
import Address from "../models/Address";
import OptionItem from "../models/OptionItem";
import StateAddress from "../models/StateAddress";


const getAddressByCEP = (cep: string) => {
  return axiosBasic.get(`/sam/v1/address/${cep}`).then(response => {
    return response.data
  })
    .catch(e => {
      console.log(e)
    })
}

const getAllStatesOptions = (): Promise<OptionItem[]> => {
  return axiosBasic.get("/sam/v1/address/getallstates").then(response => {
    let stateOption = response.data.map((row: any) => {
      return {
        "Id": row.id,
        "Text": row.description,
        "Value": row.id
      }
    });
    return stateOption
  })
    .catch(e => {
      console.log(e)
    });
};

const postInsertOrUpdateAddress = async (data: any, professionalId: string) => {

  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      }
    }

    const response = await axiosBasic.post(`/sam/v1/address/insertOrUpdate?professionalId=${encodeURIComponent(professionalId)}`, data, config);

    return await response;

  } catch (e: any) {
    throw e;
  }
};

const CreateAndGetAddressFromTasy = async (requestId: string, addressType: AddressType): Promise<Address> => {

  const response = await axiosBearer.post(`/sam/v1/address/CreateAndGetAddressFromTasy?requestId=${encodeURIComponent(requestId)}&adressType=${addressType}`, {}).then(response => {

    let adress = Address.NewInstance();
    adress.AddressName = ResolveAttrValueIfNull(response.data.addressName);
    adress.CEP = ResolveAttrValueIfNull(response.data.cep);
    adress.NumberAddress = ResolveAttrValueIfNull(response.data.numberAddress);
    adress.Complement = ResolveAttrValueIfNull(response.data.complement);
    adress.City = ResolveAttrValueIfNull(response.data.city);
    adress.State = ResolveAttrValueIfNull(response.data.state);
    adress.Neighborhood = ResolveAttrValueIfNull(response.data.neighborhood);

    if (response.data.stateAddress) {
      adress.StateAddress = new StateAddress(response.data.stateAddress.id, response.data.stateAddress.description);
    }

    return adress;
  });

  const responseData = await response;

  return responseData

};



const exportedObject = {
  getAddressByCEP,
  getAllStatesOptions,
  postInsertOrUpdateAddress,
  CreateAndGetAddressFromTasy
};


export default exportedObject
